import React, { useRef } from "react";
import Footer from "../components/Footer";

export default function DeliveryTerms() {
    const footerRef = useRef(null);

    const deliveryTerms = `Условия доставки
Условия определяют порядок доставки воды «Тибетская» по заказам в приложении «Аквамаркет Тибетская» и используются совместно с публичной офертой.

1. Товары и территория доставки
Доставка бутилированной питьевой воды «Тибетская» объёмом 18,9 и 12,5 литра осуществляется в пределах города Алматы, если иная территория не указана Оператором в приложении.

2. Организация доставки
Доставку организует ТОО «Verto Business (Верто Бизнес)» — Оператор сервиса. Фактическую передачу товара осуществляет партнёр по доставке — ТОО «Partner’s Mountain Water Co» и/или его авторизованные франчайзи. Ответственность за качество сервиса перед пользователем несёт Оператор.

3. Оформление заказа
Для оформления заказа необходимо зарегистрироваться или авторизоваться в приложении, выбрать товар и количество бутылей, указать адрес доставки, выбрать способ оплаты и подтвердить заказ. Пользователь предоставляет достоверные и актуальные контактные данные и адрес доставки.
Заказ считается принятым после подтверждения соответствующим уведомлением в приложении. Самовывоз можно выбрать, если эта возможность доступна в приложении.

4. Сроки доставки
Доставка организуется по указанному пользователем адресу в сроки и время, выбранные из доступных вариантов в приложении. Сроки доставки носят ориентировочный характер.

5. Получение заказа
При получении заказа пользователь проверяет целостность заводской упаковки и тары, а также соответствие количества бутылей оформленному заказу.
При явных повреждениях или несоответствии количества пользователь вправе отказаться от приёмки такого товара, составив акт совместно с представителем службы доставки.
Право собственности и риск случайной гибели или порчи товара переходят к пользователю в момент фактической передачи товара и подписания сопроводительных документов, если они оформляются.
Порядок предъявления претензий по качеству товара и возврата денежных средств приведён в отдельном документе «Условия оплаты и возврата».

6. Контакты Оператора
ТОО «Verto Business (Верто Бизнес)», БИН 220340005670. Адрес: Республика Казахстан, 050045, г. Алматы, мкр. Нурлытау, ул. Г. Баязитовой, д. 12. Телефон: +7 (701) 531-55-58. Электронная почта: info@tibetskaya.kz.
Полная публичная оферта: www.tibetskaya.kz/PublicOffer.
`

    const formattedTerms = deliveryTerms.split('\n').map((paragraph, index) => {
        if (paragraph.trim() === "") return null; // Пропускаем пустые строки
        return paragraph.startsWith(' ') ? <p key={index}>{paragraph.trim()}</p> : <h3 key={index}>{paragraph.trim()}</h3>;
    });

    return (
        <div className="flex flex-col min-h-screen justify-between">
            <div className="pt-5 px-5 space-y-3">
                <h2 className="text-lg font-bold">УСЛОВИЯ ДОСТАВКИ</h2>
                {formattedTerms}
            </div>

            <div className="">
                <Footer ref={footerRef} phone="+7 701 531 55 58" mail="info@tibetskaya.kz" />
            </div>
        </div>
    );
}
